<template>
  <section>
    <div
      v-if="
        fetchingConsignments &&
          consignmentsType !== 'BIN LOCATION' &&
          consignmentsType !== 'FREIGHT EVENT'
      "
    >
      <div class="t-py-4 t-text-center t-text-2xl t-font-medium t-text-gray">
        <i class="fas fa-x fa-spinner-third fa-spin"></i>
        Loading
      </div>
    </div>

    <div
      v-if="
        !fetchingConsignments &&
          consignments.data.length === 0 &&
          consignmentsType !== 'BIN LOCATION' &&
          consignmentsType !== 'FREIGHT EVENT'
      "
      class="t-py-4 t-text-center t-text-2xl t-font-medium t-text-gray"
    >
      No consignments to show
    </div>

    <bin-locations
      v-if="consignmentsType === 'BIN LOCATION'"
      :filtered-depot="$parent.depot"
    ></bin-locations>

    <freight-events
      v-if="consignmentsType === 'FREIGHT EVENT'"
    ></freight-events>

    <depot-card
      v-for="consignment in consignments.data"
      :key="consignment.id"
      :consignment="consignment"
      :consignment-type="consignmentsType"
      class="t-mb-5"
      v-else
    />

    <paginate
      v-if="
        !fetchingConsignments &&
          consignments.data.length > 0 &&
          consignmentsType !== 'BIN LOCATION' &&
          consignmentsType !== 'FREIGHT EVENT'
      "
      v-model="consignments.pagination.page"
      :page-count="consignments.pagination.lastPage"
      :page-range="5"
      :click-handler="fetchConsignments"
      :prev-text="'&laquo;'"
      :next-text="'&raquo;'"
      :prev-link-class="'page-link'"
      :next-link-class="'page-link'"
      :container-class="'pagination'"
      :page-class="'page-item'"
      :page-link-class="'page-link'"
      class="t-flex t-justify-end t-mb-2"
    />
  </section>
</template>

<script>
import DepotCard from "./DepotCard";
import BinLocations from "./BinLocations";
import FreightEvents from "./FreightEvents.vue";
import Paginate from "vuejs-paginate";

const INCOMING_ENDPOINT = "/depot/incoming";
const OUTGOING_ENDPOINT = "/depot/outgoing";

export default {
  name: "DepotIncomingConsignmentsTab",
  components: {
    DepotCard,
    BinLocations,
    FreightEvents,
    Paginate
  },
  props: {
    consignmentsType: {
      required: true
    }
  },
  data() {
    return {
      consignments: {
        data: [],
        pagination: {
          page: 1
        }
      },
      fetchingConsignments: false
    };
  },
  created() {
    this.fetchConsignments(1);
  },
  methods: {
    fetchConsignments(page, filter = null) {
      this.fetchingConsignments = true;
      this.consignments.data = [];

      let endpoint;

      if (this.consignmentsType === "INCOMING") {
        endpoint = INCOMING_ENDPOINT;
      } else if (this.consignmentsType === "OUTGOING") {
        endpoint = OUTGOING_ENDPOINT;
      } else if (this.consignmentsType === "BIN LOCATION") {
        //bin location logic goes here
      } else if (this.consignmentsType === "FREIGHT EVENT") {
        //freight event logic here
      } else {
        console.error("Unknown consignment type provided for depot page");
        endpoint = INCOMING_ENDPOINT;
      }

      if (
        this.consignmentsType !== "BIN LOCATION" &&
        this.consignmentsType !== "FREIGHT EVENT"
      ) {
        if (filter) {
          axios.get(`${endpoint}?page=${page}&depotId=${filter}`).then(res => {
            this.consignments.data = res.data.data;
            this.consignments.pagination = {
              page: res.data.meta.current_page,
              lastPage: res.data.meta.last_page
            };
            this.fetchingConsignments = false;
          });
        } else {
          axios.get(`${endpoint}?page=${page}`).then(res => {
            this.consignments.data = res.data.data;
            this.consignments.pagination = {
              page: res.data.meta.current_page,
              lastPage: res.data.meta.last_page
            };
            this.fetchingConsignments = false;
          });
        }
      }
    }
  },
  watch: {
    consignmentsType() {
      // this.$parent.depot = null;
      this.fetchConsignments(1, this.$parent.depot);
    }
  }
};
</script>

<style scoped></style>
